(() => {
  "use strict";
  customElements.get("shoppable-blog-component") ||
    customElements.define(
      "shoppable-blog-component",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.slider = this.querySelector("[data-slider]")),
            (this.flkty = null),
            (this.gutter = 0),
            (this.a11y = window.theme.a11y),
            (this.activated = !1),
            (this.controlsBound = !1),
            (this.listening = !1),
            (this.activationObserver = null),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            (this.clickOutsideItemEvent = (t) => this.clickOutsideItem(t)),
            (this.activateEvent = () => this.activate()),
            (this.sectionSelectEvent = (t) => {
              (t.target === this || t.target.contains?.(this)) &&
                this.activate();
            }));
        }
        connectedCallback() {
          this.activated
            ? this.listen()
            : window.Shopify?.designMode ||
                (function (t) {
                  const e = t.getBoundingClientRect(),
                    i =
                      window.innerHeight ||
                      document.documentElement.clientHeight;
                  return e.top <= i + 800 && e.bottom >= -800;
                })(this)
              ? this.activate()
              : (this.addEventListener("focusin", this.activateEvent, {
                  once: !0,
                }),
                this.addEventListener("pointerdown", this.activateEvent, {
                  once: !0,
                }),
                document.addEventListener(
                  "shopify:section:select",
                  this.sectionSelectEvent,
                ),
                "IntersectionObserver" in window
                  ? ((this.activationObserver = new IntersectionObserver(
                      (t) => {
                        t.some((t) => t.isIntersecting) && this.activate();
                      },
                      { rootMargin: "800px 0px" },
                    )),
                    this.activationObserver.observe(this))
                  : this.activate());
        }
        activate() {
          this.activated ||
            ((this.activated = !0),
            this.activationObserver?.disconnect(),
            (this.activationObserver = null),
            this.removeEventListener("focusin", this.activateEvent),
            this.removeEventListener("pointerdown", this.activateEvent),
            document.removeEventListener(
              "shopify:section:select",
              this.sectionSelectEvent,
            ),
            this.slider && (this.bindButtons(), this.listen()));
        }
        initSlider() {
          ((this.flkty = new window.theme.Flickity(this.slider, {
            prevNextButtons: !0,
            pageDots: !1,
            cellAlign: "left",
            wrapAround: !1,
            groupCells: !0,
            contain: !0,
            on: {
              ready: () => {
                this.handleFocus();
              },
            },
          })),
            this.flkty.on("change", () => {
              const t = this.querySelectorAll("[data-item]");
              (this.handleFocus(),
                t.forEach((t) => {
                  const e = t.querySelector("[data-item-products]");
                  (t.classList.remove("blog-item--active"),
                    e?.classList.remove("blog-item__products--visible"));
                }),
                this.flkty &&
                  !this.flkty.options.draggable &&
                  ((this.flkty.options.draggable = !0),
                  this.flkty.updateDraggable()));
            }));
        }
        destroySlider() {
          null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
        }
        checkSlidesSize() {
          const t = this.querySelector("[data-item]");
          if (!t || !this.slider) return;
          const e = t.currentStyle || window.getComputedStyle(t);
          this.gutter = parseInt(e.marginRight);
          const i =
            this.slider.offsetWidth + this.gutter < this.getItemsWidth();
          window.innerWidth >= window.theme.sizes.small && i
            ? this.initSlider()
            : this.destroySlider();
        }
        clickOutsideItem(t) {
          t.target.matches("[data-item]") ||
            t.target.closest("[data-item]") ||
            this.querySelectorAll("[data-item]").forEach((t) => {
              const e = t.querySelector("[data-item-products]");
              (e &&
                (e.classList.remove("blog-item__products--visible"),
                this.changeTabIndex(e),
                this.changeAriaHidden(e, !0)),
                t.classList.remove("blog-item--active"));
            });
        }
        getItemsWidth() {
          let t = 0;
          return (
            this.slider.querySelectorAll("[data-item]").forEach((e) => {
              t += e.offsetWidth + this.gutter;
            }),
            t
          );
        }
        bindButtons() {
          if (this.controlsBound) return;
          this.controlsBound = !0;
          const t = this.querySelectorAll("[data-item-products-slider]"),
            e = this.querySelectorAll("[data-button-show]"),
            i = this.querySelectorAll("[data-button-hide]");
          (e.forEach((t) => {
            t.addEventListener("click", (e) => {
              (e.preventDefault(),
                this.querySelectorAll("[data-item]").forEach((t) => {
                  const e = t.querySelector("[data-item-products]");
                  (t.classList.remove("blog-item--active"),
                    e &&
                      (e.classList.remove("blog-item__products--visible"),
                      this.changeTabIndex(e),
                      this.changeAriaHidden(e, !0)));
                }));
              const i = t.closest("[data-item]"),
                s = i.querySelector("[data-item-products]");
              if ((i.classList.add("blog-item--active"), s)) {
                (s.classList.add("blog-item__products--visible"),
                  this.changeTabIndex(s, "enable"),
                  this.changeAriaHidden(s, !1));
                const t = s.querySelector("[data-item-products-slider]"),
                  e = t.querySelectorAll("[data-item-product]");
                t.classList.contains("flickity-enabled") &&
                  e.forEach((t) => {
                    const e = t.classList.contains("is-selected");
                    (t.setAttribute("tabindex", e ? "0" : "-1"),
                      this.changeAriaHidden(t, !e));
                  });
              }
              (null !== this.flkty &&
                ((this.flkty.options.draggable = !1),
                this.flkty.updateDraggable()),
                (this.a11y.state.trigger = t));
            });
          }),
            i.forEach((t) => {
              t.addEventListener("click", (e) => {
                e.preventDefault();
                const i = t.closest("[data-item]"),
                  s = i.querySelector("[data-item-products]");
                (i.classList.remove("blog-item--active"),
                  s &&
                    (s.classList.remove("blog-item__products--visible"),
                    this.changeTabIndex(s),
                    this.changeAriaHidden(s, !0)),
                  null !== this.flkty &&
                    ((this.flkty.options.draggable = !0),
                    this.flkty.updateDraggable()),
                  this.a11y.state.trigger.focus());
              });
            }),
            t.forEach((t) => {
              t.querySelectorAll("[data-item-product]").length <= 1 ||
                new window.theme.Flickity(t, {
                  prevNextButtons: !0,
                  contain: !1,
                  pageDots: !1,
                  wrapAround: !1,
                  on: {
                    change: (e) => {
                      t.querySelectorAll("[data-item-product]").forEach(
                        (t, i) => {
                          const s = i === e;
                          (t.setAttribute("tabindex", s ? "0" : "-1"),
                            this.changeAriaHidden(t, !s));
                        },
                      );
                    },
                  },
                });
            }),
            this.slider.addEventListener("keyup", (t) => {
              if (t.code !== window.theme.keyboardKeys.ESCAPE) return;
              const e = t.target.hasAttribute("data-slider")
                ? t.target.querySelectorAll("[data-item]")
                : t.target
                    .closest("[data-slider]")
                    .querySelectorAll("[data-item]");
              e.length &&
                (e.forEach((t) => {
                  const e = t.querySelector("[data-item-products]");
                  (t.classList.remove("blog-item--active"),
                    e &&
                      (e.classList.remove("blog-item__products--visible"),
                      this.changeTabIndex(e),
                      this.changeAriaHidden(e, !0)));
                }),
                this.flkty &&
                  ((this.flkty.options.draggable = !0),
                  this.flkty.updateDraggable()),
                this.a11y.state.trigger.focus());
            }));
        }
        handleFocus() {
          this.querySelectorAll("[data-item]").forEach((t) => {
            const e = t.classList.contains("is-selected"),
              i = t.querySelector("[data-item-products]");
            e
              ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i))
              : (this.changeTabIndex(t),
                i?.classList.remove("blog-item__products--visible"));
          });
        }
        listen() {
          !this.listening &&
            this.slider &&
            ((this.listening = !0),
            this.checkSlidesSize(),
            document.addEventListener(
              "theme:resize:width",
              this.checkSlidesSizeOnResize,
            ),
            document.addEventListener("mousedown", this.clickOutsideItemEvent));
        }
        changeAriaHidden(t, e) {
          t.setAttribute("aria-hidden", Boolean(e));
        }
        changeTabIndex(t, e = "") {
          const i = "enable" === e ? "0" : "-1";
          t.querySelectorAll("a, button").forEach((t) => {
            t.setAttribute("tabindex", i);
          });
          const s = t.querySelectorAll("[data-item-products-slider]"),
            n = t.querySelector("[data-item-products]"),
            a = t.classList.contains("blog-item__products--visible");
          (s.forEach((t) => {
            (t.setAttribute("tabindex", a ? "0" : "-1"),
              t.querySelectorAll("[data-item-product]").forEach((t) => {
                this.changeAriaHidden(t, !a);
              }));
          }),
            n && this.changeAriaHidden(n, !a));
        }
        disconnectedCallback() {
          (this.activationObserver?.disconnect(),
            (this.activationObserver = null),
            this.removeEventListener("focusin", this.activateEvent),
            this.removeEventListener("pointerdown", this.activateEvent),
            document.removeEventListener(
              "shopify:section:select",
              this.sectionSelectEvent,
            ),
            document.removeEventListener(
              "theme:resize:width",
              this.checkSlidesSizeOnResize,
            ),
            document.removeEventListener(
              "mousedown",
              this.clickOutsideItemEvent,
            ),
            (this.listening = !1));
        }
      },
    );
})();
